<template>
  <div v-if="resource && total > 0" class="x-paginator">
    <div class="x-paginator__info">
      Mostrando <b>{{ from }}–{{ to }}</b> de <b>{{ total }}</b>
    </div>

    <div class="x-paginator__controls">
      <label v-if="perPagePath" class="x-paginator__per-page">
        Por página
        <b-form-select
          size="sm"
          :value="Number(resource.per_page)"
          :options="perPageOptions"
          :disabled="disabled"
          @change="changePerPage"
        />
      </label>

      <b-pagination
        v-if="resource.last_page > 1"
        :disabled="disabled"
        :value="resource.current_page"
        :total-rows="total"
        :per-page="Number(resource.per_page)"
        :aria-controls="ariaControls"
        size="sm"
        limit="5"
        first-number
        last-number
        prev-text="‹"
        next-text="›"
        @change="change"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: 'Paginator',

  props: {
    ariaControls: String,

    showPath: String,

    resource: Object,

    disabled: Boolean,

    moreData: Object,

    /**
     * Acción de vuex que cambia cuántos registros hay por página.
     * Si no se indica, no se muestra el selector.
     */
    perPagePath: {
      type: String,
      default: null
    },

    perPageOptions: {
      type: Array,
      default: () => [15, 25, 50]
    }
  },

  computed: {
    total () {
      return Number(this.resource.total) || 0
    },

    from () {
      if (this.resource.from) return this.resource.from

      return (this.resource.current_page - 1) * this.resource.per_page + 1
    },

    to () {
      if (this.resource.to) return this.resource.to

      return Math.min(this.resource.current_page * this.resource.per_page, this.total)
    }
  },

  methods: {
    /**
     * Si se van a pasar mas parametros al paginador a parte de
     * la propia pagina, mandar a traves de moreData
     */
    change (page) {
      if (this.moreData) {
        this.$store.dispatch(`${this.showPath}`, {
          page: page,
          ...this.moreData
        })
      } else {
        this.$store.dispatch(`${this.showPath}`, page)
      }
    },

    changePerPage (perPage) {
      this.$store.dispatch(this.perPagePath, perPage)
    }
  }
}
</script>

<style lang="scss" scoped>
.x-paginator {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 0.5rem 1rem;
  padding: 0.75rem 0.25rem 0.25rem;
}

.x-paginator__info {
  font-size: 0.8rem;
  color: #69707a;

  b {
    color: #212832;
    font-weight: 600;
  }
}

.x-paginator__controls {
  display: flex;
  align-items: center;
  gap: 1rem;
  margin-left: auto;
}

.x-paginator__per-page {
  display: flex;
  align-items: center;
  gap: 0.4rem;
  margin: 0;
  font-size: 0.8rem;
  color: #69707a;
  white-space: nowrap;

  select {
    width: auto;
  }
}
</style>
